import { render } from "./MessageBoxQuickBuy.vue?vue&type=template&id=00023497"
import script from "./MessageBoxQuickBuy.vue?vue&type=script&lang=js"
export * from "./MessageBoxQuickBuy.vue?vue&type=script&lang=js"

import "./MessageBoxQuickBuy.vue?vue&type=style&index=0&id=00023497&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__